import {
  Table,
  TableOnCellClick,
  TablePaginationProps,
  TableSetRowHref,
  TableSortProps,
} from 'libs/ui';

import { OrdersListItem, SortField } from '../../types';

import { useColumns } from './columns';

export interface OrdersTableProps
  extends TablePaginationProps,
    TableSortProps<SortField> {
  orders: OrdersListItem[];
  loading?: boolean;
  brokerTimezoneOffset: number;
  onCellClick?: TableOnCellClick<OrdersListItem>;
  setRowHref?: TableSetRowHref<OrdersListItem>;
  noRowsLabel?: string;
}

export const OrdersTable = ({
  orders,
  loading,
  limit,
  rowCount,
  page,
  sort,
  brokerTimezoneOffset,
  onSortChange,
  onCellClick,
  onPaginationChange,
  setRowHref,
  noRowsLabel,
}: OrdersTableProps) => {
  const columns = useColumns({ brokerTimezoneOffset });

  return (
    <Table
      columns={columns}
      limit={limit}
      loading={loading}
      noRowsLabel={noRowsLabel}
      page={page}
      rowCount={rowCount}
      rowHeight={60}
      rows={orders}
      setRowHref={setRowHref}
      sort={sort}
      onCellClick={onCellClick}
      onPaginationChange={onPaginationChange}
      onSortChange={onSortChange}
    />
  );
};
